import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "collapsible", "content", "expanded"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Collapse } from '@flowio/react-collapse';
import { colors } from '@flowio/react-theme';
import React from 'react';
var rootStyles = /*#__PURE__*/css({
  padding: '16px 10px',
  backgroundColor: colors.GRAY_200,
  borderTop: "1px solid ".concat(colors.GRAY_500)
}, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var PanelContent = function PanelContent(_ref) {
  var children = _ref.children,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? '' : _ref$content,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var ariaProps = {};

  if (collapsible) {
    ariaProps.role = 'tabpanel';
    ariaProps['aria-hidden'] = !expanded;
    ariaProps['aria-expanded'] = expanded;
  }

  var panelContent = jsx("div", _extends({}, ariaProps, unhandledProps, {
    css: rootStyles
  }), children != null ? children : content);

  if (!collapsible) {
    return panelContent;
  }

  return jsx(Collapse, {
    expanded: expanded
  }, panelContent);
};

PanelContent.displayName = 'PanelContent';
export default PanelContent;